module.exports = __webpack_public_path__ + "img/YV.6a6bf975.png";